import {RankedTester, rankWith, schemaMatches} from "@jsonforms/core";
import {schemaByDataset} from "../schema/schema.by.dataset";
import {Dataset} from "@rezonence/core";
const micrositesSchema = schemaByDataset[Dataset.Microsites];
export const micrositesRendererTester: RankedTester = rankWith(7,
  schemaMatches(schema =>
    schema.definitions &&
    JSON.stringify(Object.keys(schema.definitions)) === JSON.stringify(Object.keys(micrositesSchema.definitions))
  ));
